import React from 'react'
import SDKContainerThemed from '_uikit/sdk-container'

const Index = ({ children }) => {
  return <SDKContainerThemed>{children}</SDKContainerThemed>
}

export default Index
